import { config } from "react-spring";
import TextTransition from "./components/TextTransition";
export default TextTransition;
export { config as presets };